import './rank-popup.less';
import React from 'react';
import endpoints from '../../../../../config/endpoints';
import axios from 'axios';
import { Link } from 'react-router';

import getRankData from '../../../../../modules/shared/get-rank-data';

import PropTypes from 'prop-types';

const propTypes = {
	intl: PropTypes.func.isRequired
};

class User extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			rankMonthlyPoints: 0,
			rankData: {
				rank_id: 0
			}
		};
	}

	componentDidMount() {
		const fetchRequest = () => {
			return axios({ method: 'GET', url: endpoints.RANKS.INFO})
				.then(data => this.setState({
					rankMonthlyPoints: data.data.points_per_month,
					rankData: data.data
				}));
		};
		this.interval = setInterval(fetchRequest, 30000);
		fetchRequest();
	}
	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render() {
		const { intl } = this.props;

		const rank = getRankData(this.state.rankData.rank_id, intl);

		return !!rank && (
			<div className="current-rank__container" onClick={e => { e.preventDefault();}}>
				<div className="current-rank__popup">
					<div className="rank-description">
						<img className="rank-description__image" src={rank.status.image}/>
						<div className="rank-description__container">
							<div className="rank__name font-proxima-nova-semibold">
								{`${rank.status.title} `}
								<span className="points">
									{this.state.rankMonthlyPoints} QUID
								</span>
							</div>
							<div className="rank_text font-proxima-nova-regular">
								{rank.description}
							</div>
							<Link
								className="bottom__link font-proxima-nova-semibold"
								onClick={e => {e.stopPropagation();}}
								to='ranks'
							>
								{intl('Подробнее о программе')}
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

User.propTypes = propTypes;

export default User;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/top/components/rank-popup.js